var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 17,
    viewBox: "0 0 23 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.344 4.01669C22.344 4.01669 22.1297 2.5042 21.4699 1.84008C20.6344 0.966004 19.7003 0.961719 19.2719 0.910303C16.2041 0.6875 11.598 0.6875 11.598 0.6875H11.5895C11.5895 0.6875 6.98345 0.6875 3.91563 0.910303C3.48716 0.961719 2.5531 0.966004 1.71759 1.84008C1.05775 2.5042 0.847803 4.01669 0.847803 4.01669C0.847803 4.01669 0.625 5.79482 0.625 7.56868V9.23113C0.625 11.005 0.843518 12.7831 0.843518 12.7831C0.843518 12.7831 1.05775 14.2956 1.71331 14.9597C2.54882 15.8338 3.64569 15.8038 4.13414 15.8981C5.89086 16.0652 11.5938 16.1166 11.5938 16.1166C11.5938 16.1166 16.2041 16.108 19.2719 15.8895C19.7003 15.8381 20.6344 15.8338 21.4699 14.9597C22.1297 14.2956 22.344 12.7831 22.344 12.7831C22.344 12.7831 22.5625 11.0093 22.5625 9.23113V7.56868C22.5625 5.79482 22.344 4.01669 22.344 4.01669ZM9.32716 11.2492V5.08357L15.2529 8.1771L9.32716 11.2492Z",
    fill: "#737373"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.4c025459.svg";
export { ForwardRef as ReactComponent };